import * as React from "react";
import type { SVGProps } from "react";
const SvgMinusCircleContained = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.4 12h7.2m6 0a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 1 1 19.2 0"
    />
  </svg>
);
export default SvgMinusCircleContained;
